export { default } from './WizardPostSendView';
